module.exports = __webpack_public_path__ + "img/icon-1.5c34e69d.png";